import { render, staticRenderFns } from "./FleetOverview.vue?vue&type=template&id=627ac168"
import script from "./FleetOverview.vue?vue&type=script&lang=js"
export * from "./FleetOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports